module.exports = __webpack_public_path__ + "static/media/cloud-computing-programming-language-svgrepo-com.5cbd49a0.svg";